import { defineComponent as _defineComponent } from 'vue'
import { useQuery } from "@vue/apollo-composable"
import { FilterType } from "@/components/widgets/common/FilterBar.vue"

import {
  MyMissionsListsQuery,
  MyMissionsListsQueryQuery,
  MyMissionsListsQueryQueryVariables,
  MissionLifecycleState,
} from "@/gql"
import { ref, computed } from "vue"
import ConsultantMissionsList from "@/modules/Missions/Consultant/ConsultantMissionsList.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'CompletedMissions',
  setup(__props) {

const filter = ref<FilterType>({})

const completedQueryFilter = computed(() => {
  return {
    search: filter.value.search,
    createdAtDate: filter.value.createdAtDate,
    state: MissionLifecycleState.Completed,
  }
})

const { loading, result } = useQuery<MyMissionsListsQueryQuery, MyMissionsListsQueryQueryVariables>(
  MyMissionsListsQuery,
  {
    per: 10,
    filter: completedQueryFilter.value,
  }
)

return { __sfc: true,filter, completedQueryFilter, loading, result, ConsultantMissionsList }
}

})